import * as contentful from 'contentful';
import isNull from 'lodash/isNull';
import { isNonEmptyString } from '../../../utilities/isNonEmptyString';
import {
  CREDIT_SNAP,
  DEFAULT_APPLICATION_SUBMISSION_API,
  DEFAULT_EMAIL_ADDRESS,
  DEFAULT_FAVICON,
  DEFAULT_HEIGHT,
  DEFAULT_MAIL_CODE_SOURCE,
  DEFAULT_PHONE_NUMBER,
  DEFAULT_WIDTH,
  DEFAULT_WORKFLOW,
  RATE_GENIUS
} from '../../../values/brand';

/**
 * @param {string|null} phoneNumber
 * @returns {string|null}
 */
const getPhoneNumberWithCountryCode = (phoneNumber) => {
  if (isNull(phoneNumber)) {
    return null;
  }

  return phoneNumber.startsWith('1-') ? phoneNumber : `1-${phoneNumber}`;
};

export const getters = {
  applicationSubmissionApi: state =>
    isNull(state.applicationSubmissionApi) ? DEFAULT_APPLICATION_SUBMISSION_API : state.applicationSubmissionApi,
  bearerToken: state => state.bearerToken,
  emailAddress: state =>
    isNull(state.emailAddress) ? DEFAULT_EMAIL_ADDRESS : state.emailAddress,
  favicon: state =>
    isNull(state.favicon) ? DEFAULT_FAVICON : state.favicon,
  footerLogoAlt: state => state.footerLogo.alt,
  footerLogoHeight: state =>
    isNull(state.footerLogo.height) ? DEFAULT_HEIGHT : state.footerLogo.height,
  footerLogoSrc: state => state.footerLogo.src,
  footerLogoWidth: state =>
    isNull(state.footerLogo.width) ? DEFAULT_WIDTH : state.footerLogo.width,
  headerLogoAlt: state => state.headerLogo.alt,
  headerLogoHeight: state =>
    isNull(state.headerLogo.height) ? DEFAULT_HEIGHT : state.headerLogo.height,
  headerLogoSrc: state => state.headerLogo.src,
  headerLogoWidth: state =>
    isNull(state.headerLogo.width) ? DEFAULT_WIDTH : state.headerLogo.width,
  isAutopayBrand: state =>
    isNull(state.name) || state.name.includes('AUTOPAY'),
  leadChannel: state => state.leadChannel,
  mailCodeSource: state =>
    isNonEmptyString(state.mailCodeSource)
      ? state.mailCodeSource
      : DEFAULT_MAIL_CODE_SOURCE,
  name: state => state.name,
  organizationCode: state => state.organizationCode,
  phoneNumber: state =>
    isNull(state.phoneNumber) ? DEFAULT_PHONE_NUMBER : state.phoneNumber,
  phoneNumberWithCountryCode: (state, { phoneNumber }) =>
    getPhoneNumberWithCountryCode(phoneNumber),
  shouldSubmitToCreditSnap: (state, { applicationSubmissionApi }) =>
    applicationSubmissionApi === CREDIT_SNAP,
  shouldSubmitToRateGenius: (state, { applicationSubmissionApi }) =>
    applicationSubmissionApi === RATE_GENIUS,
  stylesheet: state => state.stylesheet,
  workflow: state =>
    isNull(state.workflow) ? DEFAULT_WORKFLOW : state.workflow,

  client: () => {
    return contentful.createClient({
      accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
      environment: process.env.CONTENTFUL_ENVIRONMENT_ID,
      space: process.env.CONTENTFUL_SPACE_ID
    });
  }
};
